/*jshint esversion: 9 */
import React from "react";
import { connect } from "react-redux";
import { Fragment } from "react";
// import { withStyles } from "@material-ui/core/styles";
// import { doLog, getNumber, hasValue, updateObject } from "../../shared/utility";
import { doLog, hasValue, updateObject } from "../../shared/utility";

import * as actions from "../../store/actions/index";
import Button from "@material-ui/core/Button";
import classes from "../CrimeSubmission.css";
import confirm from "../../shared/confirm";
import Grid from "@material-ui/core/Grid";
import Form from "../../components/UI/Form/Form";

const mappedSelectPropFields = [];

const mappedTextPropFields = [
  "CODEGROUPID",
  "CODEGROUPSEQNUMBER",
  "CODEVALUE",
  "DESCRIPTION",
  "ORI",
  "ACTIVEFLAG",
];
// If fields are added to this list, also update getMappedPropValue and putMappedPropValue functions

const supportedValidCodeGroups = [
  {
    name: "Race",
    label: "Race",
    codeGroupID: 8,
    codeValueLabel: "Race Code",
    codeValueSize: 1,
    descriptionLabel: "Description",
    listName: "raceList",
  },
  {
    name: "Ethnicity",
    label: "Ethnicity",
    codeGroupID: 10,
    codeValueLabel: "Ethnicity Code",
    codeValueSize: 1,
    descriptionLabel: "Description",
    listName: "ethnicityList",
  },
  {
    name: "Gender",
    label: "Gender",
    codeGroupID: 9,
    codeValueLabel: "Gender Code",
    codeValueSize: 1,
    descriptionLabel: "Description",
    listName: "sexList",
  },
  {
    name: "EyeColor",
    label: "Eye Color",
    codeGroupID: 13,
    codeValueLabel: "Eye Color Code",
    codeValueSize: 3,
    descriptionLabel: "Description",
    listName: "eyeColorList",
  },
  {
    name: "HairColor",
    label: "Hair Color",
    codeGroupID: 14,
    codeValueLabel: "Hair Color Code",
    codeValueSize: 3,
    descriptionLabel: "Description",
    listName: "hairColorList",
  },
  {
    name: "VehicleBodyStyle",
    label: "Vehicle Body Style",
    codeGroupID: 17,
    codeValueLabel: "Vehicle Body Style Code",
    codeValueSize: 12,
    descriptionLabel: "Description",
    listName: "vehicleBodyStyleList",
  },
  {
    name: "PropertyType",
    label: "Property Type",
    codeGroupID: 29,
    codeValueLabel: "Property Type Code",
    codeValueSize: 2,
    descriptionLabel: "Description",
    listName: "propertyTypeList",
  },
  {
    name: "VehicleInvolvement",
    label: "Vehicle Involvement",
    codeGroupID: 164,
    codeValueLabel: "Involvement Role Code",
    codeValueSize: 3,
    descriptionLabel: "Description",
    listName: "vehicleInvolvementList",
  },
  {
    name: "VehicleMake",
    label: "Vehicle Make",
    codeGroupID: 160,
    codeValueLabel: "Vehicle Make Code",
    codeValueSize: 25,
    descriptionLabel: "Description",
    listName: "vehicleMakeList",
  },
  {
    name: "VehiclePropertyColor",
    label: "Vehicle/Property Color",
    codeGroupID: 161,
    codeValueLabel: "Color Code",
    codeValueSize: 10,
    descriptionLabel: "Description",
    listName: "vehicleColorList",
  },
  {
    name: "State",
    label: "State",
    codeGroupID: 162,
    codeValueLabel: "State Code",
    codeValueSize: 2,
    descriptionLabel: "Description",
    listName: "stateList",
  },
  {
    name: "PersonInvolvement",
    label: "Person Involvement",
    codeGroupID: 163,
    codeValueLabel: "Involvement Role Code",
    codeValueSize: 3,
    descriptionLabel: "Description",
    listName: "personInvolvementList",
  },
];

// const styles = (theme) => ({
//   root: {
//     flexGrow: 1,
//     backgroundColor: theme.palette.background.paper,
//   },
//   textField: {
//     width: 250,
//   },
//   dense: {
//     marginTop: 19,
//   },
//   spacing: 1,
// });

const gridSpacing = 0; //0 or 8 or 16 or 24 or 32 or 40
const quote = '"';
// const singleQuote = "'";

class ManageValidCode extends Form {
  state = {
    searching: false,
    editMode: true,
    timeoutSecs: 10,
    requiredFieldErrMsg: "Required fields are needed",
    keyFieldValue: null,
    //
    selectedGroup: null,
    actionOption: null,
    actionEdit: false,
    actionAdd: false,
    itemChanged: false,
    item: null,
    //
    mappedSelectPropFields: mappedSelectPropFields,
    mappedTextPropFields: mappedTextPropFields,
    //
    CODEGROUPID: {
      inputType: "number",
      value: "",
      label: "Code Group ID",
      validation: { required: true },
    },
    CODEGROUPSEQNUMBER: {
      inputType: "number",
      value: "",
      label: "Sequence Number",
      validation: { required: true },
    },
    CODEVALUE: {
      inputType: "text",
      value: "",
      label: "Code Value",
      upperOnly: true,
      validation: { required: true },
    },
    DESCRIPTION: {
      inputType: "text",
      value: "",
      label: "Description",
      validation: { required: true },
    },
    ORI: {
      inputType: "text",
      value: "",
      label: "ORI",
      upperOnly: true,
      validation: { required: false },
      disabled: true,
    },
    ACTIVEFLAG: {
      inputType: "checkbox",
      value: "Y",
      label: "Active",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    DELETEDFLAG: {
      inputType: "checkbox",
      value: "N",
      label: "Deleted",
      checkedValue: "Y",
      uncheckedValue: "N",
    },
    //
    selectValidCode: {
      inputType: "datagrid",
      labelValue: null,
      value: null,
      // label: "Select a Code to Edit",
      // validation: { required: true },
      useSearch: true,
      searchText: "",
      gridColumns: [],
      gridDefaultRows: [],
      gridRows: [],
      rowCount: 4,
      onGridRowClick: (fieldName) => (param, event) => {
        this.handleRowClick(fieldName, param, event);
      },
    },
    //
  };

  componentDidMount() {
    if (doLog())
      console.log("[ManageValidCode] componentDidMount state:", this.state);
    if (doLog())
      console.log("[ManageValidCode] componentDidMount props:", this.props);
    this.copyGroupValuesToState();
    this.setState({
      ORI: updateObject(this.state.ORI, {
        value: this.props.ori,
      }),
    });
  }

  componentDidUpdate() {
    if (doLog())
      console.log("[ManageValidCode] componentDidUpdate state:", this.state);
    if (doLog())
      console.log("[ManageValidCode] componentDidUpdate props:", this.props);
    if (
      this.state.searching &&
      hasValue(this.props.result) &&
      !this.props.loading &&
      this.props.error === null &&
      hasValue(this.state.selectedGroup)
    ) {
      if (doLog())
        console.log(
          "[ManageValidCode] componentDidUpdate searching selectedGroup:",
          this.state.selectedGroup
        );
      this.setState({ searching: false });
      this.props.onClearValidCodeList(this.state.selectedGroup.listName);
    } else if (
      !this.state.searching &&
      !this.props.loading &&
      hasValue(this.state.selectedGroup)
    ) {
      if (doLog())
        console.log(
          "[ManageValidCode] componentDidUpdate selectedGroup:",
          this.state.selectedGroup
        );
      if (this.props[this.state.selectedGroup.listName] === null) {
        if (doLog())
          console.log(
            "[ManageValidCode] componentDidUpdate fetching " +
              this.state.selectedGroup.listName
          );
        this.props.onFetchValidCodeLists(
          this.props.ori,
          this.props.token,
          this.state.selectedGroup.listName,
          this.state.selectedGroup.codeGroupID,
          true,
          true
        );
      } else if (this.state.itemChanged) {
        this.copyFieldValuesToState();
        this.setState({ itemChanged: false });
      } else {
        let array = null;
        if (hasValue(this.props[this.state.selectedGroup.listName])) {
          array = this.props[this.state.selectedGroup.listName];
        }

        if (doLog())
          console.log("[ManageValidCode] componentDidUpdate array:", array);
        if (
          array !== null &&
          this.state.selectValidCode.gridDefaultRows.length === 0
        ) {
          this.loadGridRows(array);
        }
      }
    }
  }

  copyFieldValuesToState() {
    if (doLog())
      console.log(
        "[ManageValidCode]copyFieldValuesToState item:",
        this.state.item
      );
    if (hasValue(this.state.item)) {
      const item = this.state.item;
      for (let field in this.state.mappedTextPropFields) {
        const fieldName = this.state.mappedTextPropFields[field];
        if (doLog())
          console.log(
            "[ManageValidCode]copyFieldValuesToState text field:",
            fieldName
          );
        const newValue = item[fieldName];
        if (doLog())
          console.log(
            "[ManageValidCode]copyFieldValuesToState text newValue:",
            newValue
          );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: item[fieldName],
          }),
        });
        if (this.state[fieldName].keyField === true) {
          this.setState({ keyFieldValue: item[fieldName] });
        }
      }

      for (let field in this.state.mappedSelectPropFields) {
        const fieldName = this.state.mappedSelectPropFields[field];
        if (doLog())
          console.log(
            "[ManageValidCode]copyFieldValuesToState select field:",
            fieldName
          );
        this.setState({
          [fieldName]: updateObject(this.state[fieldName], {
            value: item[fieldName],
          }),
        });
      }
    }
  }

  copyGroupValuesToState() {
    if (doLog())
      console.log(
        "[ManageValidCode]copyGroupValuesToState listName:",
        this.props.listName
      );
    if (hasValue(this.props.listName)) {
      const selectedGroup = supportedValidCodeGroups.find(
        (option) => option.name === this.props.listName
      );
      if (doLog())
        console.log(
          "[ManageValidCode]copyGroupValuesToState selectedGroup:",
          selectedGroup
        );
      if (selectedGroup !== null) {
        this.setState({
          selectedGroup: selectedGroup,
          CODEVALUE: updateObject(this.state.CODEVALUE, {
            label: selectedGroup.codeValueLabel,
            description: selectedGroup.descriptionLabel,
            maxSize: selectedGroup.codeValueSize,
          }),
        });
      }
    }
  }

  // getNextSeqNumber = () => {
  //   let array = null;
  //   if (hasValue(this.props[this.state.selectedGroup.listName])) {
  //     array = this.props[this.state.selectedGroup.listName];
  //   }
  //   const size = array.length;
  //   // if (doLog()) console.log("[ManageValidCode] getNextSeqNumber size:", size);
  //   let maxSeqNumber = 0;
  //   for (let i = 0; i < size; i++) {
  //     const fieldValue = array[i].CODEGROUPSEQNUMBER;
  //     const seqNumber = getNumber(fieldValue);
  //     // if (doLog()) console.log("[ManageValidCode] getNextSeqNumber seqNumber:", seqNumber);
  //     if (seqNumber > maxSeqNumber) maxSeqNumber = seqNumber;
  //   }

  //   maxSeqNumber++;
  //   if (doLog())
  //     console.log("[ManageValidCode] getNextSeqNumber:" + maxSeqNumber);
  //   return maxSeqNumber;
  // };

  handleAddButton = () => {
    if (doLog()) console.log("[ManageValidCode] handleAddButton");
    this.setState({
      actionEdit: false,
      actionAdd: true,
      CODEGROUPID: updateObject(this.state.CODEGROUPID, {
        value: this.state.selectedGroup.codeGroupID,
      }),
      CODEVALUE: updateObject(this.state.CODEVALUE, {
        value: "",
      }),
      DESCRIPTION: updateObject(this.state.DESCRIPTION, {
        value: "",
      }),
      ORI: updateObject(this.state.ORI, {
        value: this.props.ori,
      }),
      ACTIVEFLAG: updateObject(this.state.ACTIVEFLAG, {
        value: "Y",
      }),
    });
  };

  handleCancelButton = () => {
    if (doLog()) console.log("[ManageValidCode] handleCancelButton");
    this.setState({ actionEdit: false, actionAdd: false });
  };

  handleDeleteButton = () => {
    if (doLog()) console.log("[ManageValidCode] handleDeleteButton");
    confirm("Are you sure you want to delete?", {
      title:
        "Delete " +
        this.state.selectedGroup.name +
        ": " +
        this.state.DESCRIPTION.value,
      okLabel: "Yes",
    }).then(
      (result) => {
        if (doLog()) console.log("delete confirmed");
        const whereStr =
          ' WHERE="CODEGROUPID=' +
          this.state.item.CODEGROUPID +
          " AND CODEGROUPSEQNUMBER=" +
          this.state.item.CODEGROUPSEQNUMBER +
          quote;
        const command =
          '<CIDDB><DELETEROW TABLE="VALIDCODE"' +
          whereStr +
          ' OPERATORID="-1" REASON="Remove from CitizenWeb"/></CIDDB>';
        if (doLog())
          console.log("[ManageValidCode] handleDeleteButton command:", command);
        const transactionType = command;
        const data = {};
        const request = {
          transactionType,
          data,
        };
        // this.setState({
        //   searching: true,
        //   selectValidCode: updateObject(this.state.selectValidCode, {
        //     gridDefaultRows: [],
        //   }),
        // });
        this.props.onRunTransaction(
          request,
          this.props.token,
          "validCodeUpdate"
        );
        this.props.onClearValidCodeList(this.state.selectedGroup.listName);
        this.setState({
          searching: true,
          selectValidCode: updateObject(this.state.selectValidCode, {
            gridDefaultRows: [],
          }),
          actionEdit: false,
          actionAdd: false,
          actionOption: null,
        });
      },
      (result) => {
        if (doLog()) console.log("delete cancelled");
        if (doLog()) console.log(result);
      }
    );
  };

  handleSubmitAddButton = () => {
    if (doLog()) console.log("[ManageValidCode] handleSubmitAddButton");
    const noAdd = false;
    this.issueSubmit(noAdd);
    this.setState({
      actionEdit: false,
      actionAdd: true,
      CODEGROUPID: updateObject(this.state.CODEGROUPID, {
        value: this.state.selectedGroup.codeGroupID,
      }),
      CODEVALUE: updateObject(this.state.CODEVALUE, {
        value: "",
      }),
      DESCRIPTION: updateObject(this.state.DESCRIPTION, {
        value: "",
      }),
      ORI: updateObject(this.state.ORI, {
        value: this.props.ori,
      }),
      ACTIVEFLAG: updateObject(this.state.ACTIVEFLAG, {
        value: "Y",
      }),
    });
  };

  handleSubmitButton = () => {
    if (doLog())
      console.log(
        "[ManageValidCode] handleSubmitButton add:" + this.state.actionAdd
      );
    const doAdd = this.state.actionAdd;
    this.issueSubmit(doAdd);
    this.setState({ actionEdit: false, actionAdd: false, actionOption: null });
  };

  issueSubmit = (doAdd) => {
    let data = null;
    let transactionType = null;
    if (doAdd) {
      transactionType = "AddCitizenValidCode";
      data = {
        ori: this.state.ORI.value,
        codeGroupID: "" + this.state.CODEGROUPID.value,
        codeValue: this.state.CODEVALUE.value,
        description: this.state.DESCRIPTION.value,
      };
    } else {
      let operationType = "UPDATEROW";
      let whereStr = "";
      let reasonType = "Update";
      let seqNumber = null;
      seqNumber = this.state.item.CODEGROUPSEQNUMBER;
      whereStr =
        ' WHERE="CODEGROUPID=' +
        this.state.item.CODEGROUPID +
        " AND CODEGROUPSEQNUMBER=" +
        seqNumber +
        quote;
      // }
      transactionType =
        "<CIDDB><" +
        operationType +
        ' TABLE="ValidCode"' +
        whereStr +
        ' OPERATORID="-1" REASON="' +
        reasonType +
        ' from CitizenWeb">' +
        this.fieldTag("CODEGROUPID") +
        this.fieldTagValue("CODEGROUPSEQNUMBER", seqNumber) +
        this.fieldTag("CODEVALUE") +
        this.fieldTag("DESCRIPTION") +
        this.fieldTag("ORI") +
        this.fieldTag("ACTIVEFLAG") +
        "</" +
        operationType +
        "></CIDDB>";
    }
    if (doLog())
      console.log(
        "[ManageValidCode] issueSubmit transactionType:",
        transactionType
      );
    const request = {
      transactionType,
      data,
    };
    this.setState({
      searching: true,
      selectValidCode: updateObject(this.state.selectValidCode, {
        gridDefaultRows: [],
      }),
    });
    this.props.onRunTransaction(request, this.props.token, "validCodeUpdate");
    this.props.onClearValidCodeList(this.state.selectedGroup.listName);
  };

  handleRowClick = (fieldName, param, event) => {
    if (doLog())
      console.log("[ManageValidCode] handleRowClick fieldName:", fieldName);
    if (doLog()) console.log("[ManageValidCode] handleRowClick param:", param);
    if (doLog()) console.log("[ManageValidCode] handleRowClick event:", event);
    if (param != null && param.row != null) {
      const row = param.row;
      const codeValue = row.codeValue;
      const optionSelected = { value: row.id, label: row.description };
      //   if (doLog()) console.log("[ManageValidCode] handleRowClick optionSelected:", optionSelected);
      let array = null;
      if (hasValue(this.props[this.state.selectedGroup.listName])) {
        array = this.props[this.state.selectedGroup.listName];
      }
      const item = array[row.id];
      this.setState({
        actionOption: optionSelected,
        actionEdit: true,
        actionAdd: false,
        item: item,
        itemChanged: true,
      });
      this.setState({
        [fieldName]: updateObject(this.state[fieldName], {
          value: codeValue,
        }),
      });
    }
  };

  loadGridRows = (array) => {
    if (doLog()) console.log("[ManageValidCode] loadGridRows");
    const listRows = [];
    for (let i = 0; i < array.length; i++) {
      const fields = array[i];
      if (fields.DELETEDFLAG !== "Y") {
        listRows.push({
          id: i,
          codeValue: fields.CODEVALUE,
          description: fields.DESCRIPTION,
        });
      }
    }
    const codeValueLabel = this.state.selectedGroup.codeValueLabel;
    const descriptionLabel = this.state.selectedGroup.descriptionLabel;
    const gridColumns = [
      {
        field: "codeValue",
        renderHeader: (params) => <strong>{codeValueLabel}</strong>,
        width: 300,
      },
      {
        field: "description",
        renderHeader: (params) => <strong>{descriptionLabel}</strong>,
        width: 300,
      },
    ];

    this.setState({
      gridDefaultRows: listRows,
      gridRows: listRows,
      selectValidCode: updateObject(this.state.selectValidCode, {
        gridDefaultRows: listRows,
        gridRows: listRows,
        gridColumns: gridColumns,
      }),
    });
  };

  render() {
    if (doLog())
      console.log(
        "[ManageValidCode]render selectedGroup:",
        this.state.selectedGroup
      );
    let informationSection = null;
    if (this.state.selectedGroup) {
      const editType = this.state.actionAdd ? "Add" : "Edit";
      let description = "";
      if (hasValue(this.state.item) && hasValue(this.state.DESCRIPTION.value))
        description = ": " + this.state.DESCRIPTION.value;
      informationSection = (
        <p className={classes.Information}>
          {editType} {this.state.selectedGroup.label}
          {description}
        </p>
      );
    }

    let activeSection = null;
    let formSection = null;
    if (this.state.selectedGroup !== null && !this.state.searching) {
      let addButtonSection = (
        <Grid item xs={12}>
          <Button
            variant="contained"
            //color="default"
            color="primary"
            size="small"
            onClick={this.handleAddButton.bind(this)}
          >
            Add Another
          </Button>
        </Grid>
      );
      if (this.state.actionEdit === true || this.state.actionAdd === true) {
        addButtonSection = (
          <Grid item xs={12}>
            {" "}
          </Grid>
        );
      }

      const optionSelect = (
        <Fragment>
          <Grid item xs={12}>
            {this.getFormField("selectValidCode", false, true)}
          </Grid>
          {addButtonSection}
        </Fragment>
      );

      activeSection = <Fragment>{optionSelect}</Fragment>;

      if (this.state.actionEdit === true || this.state.actionAdd === true) {
        formSection = (
          <Grid container item className={classes.Card} spacing={gridSpacing}>
            {informationSection}
            <Grid item xs={12}>
              <hr />
            </Grid>
            <Grid item xs={4}>
              {this.getFormField("CODEVALUE", false, true)}
            </Grid>
            <Grid item xs={8} />
            <Grid item xs={8} />
            <Grid item xs={12}>
              {this.getFormField("DESCRIPTION", false, true)}
            </Grid>
            {/* <Grid item xs={4}>
              {this.getFormField("ORI", false, true)}
            </Grid> */}
            <Grid item xs={4}>
              {this.getFormField("ACTIVEFLAG", false, true)}
            </Grid>
            <Grid item xs={8} />
            <Grid item xs={12}>
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleSubmitButton.bind(this)}
              >
                Submit
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleSubmitAddButton.bind(this)}
              >
                Submit/Add Another
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleDeleteButton.bind(this)}
              >
                Delete
              </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <Button
                variant="contained"
                //color="default"
                color="primary"
                size="small"
                onClick={this.handleCancelButton.bind(this)}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        );
      }
    }

    return (
      <Grid container item spacing={gridSpacing}>
        {activeSection}
        {formSection}
      </Grid>
    );
  }
}

const mapStateToProps = (state) => {
  if (doLog()) console.log("[ManageValidCode] mapStateToProps state:", state);
  return {
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    //
    loading: state.trans.loading,
    result: state.trans.result,
    transDesc: state.trans.transDesc,
    error: state.trans.error,
    //
    configuration: state.trans.configuration,
    //
    raceList: state.trans.raceList,
    ethnicityList: state.trans.ethnicityList,
    sexList: state.trans.sexList,
    stateList: state.trans.stateList,
    eyeColorList: state.trans.eyeColorList,
    hairColorList: state.trans.hairColorList,
    propertyTypeList: state.trans.propertyTypeList,
    propertyColorList: state.trans.propertyColorList,
    personInvolvementList: state.trans.personInvolvementList,
    vehicleInvolvementList: state.trans.vehicleInvolvementList,
    vehicleBodyStyleList: state.trans.vehicleBodyStyleList,
    vehicleMakeList: state.trans.vehicleMakeList,
    vehicleColorList: state.trans.vehicleColorList,
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onRunTransaction: (options, token, transDesc) =>
      dispatch(actions.runTransaction(options, token, transDesc)),
    onClearTransactionResult: () => dispatch(actions.clearTransactionResult()),
    onClearValidCodeList: (listName) =>
      dispatch(actions.clearValidCodeList(listName)),
    onFetchValidCodeLists: (
      ori,
      token,
      listName,
      codeGroup,
      allFields,
      includeInactive
    ) =>
      dispatch(
        actions.fetchValidCodeLists(
          ori,
          token,
          listName,
          codeGroup,
          allFields,
          includeInactive
        )
      ),
  };
};

// export default withStyles(styles)(
//   connect(mapStateToProps, mapDispatchToProps)(ManageValidCode)
// );
export default connect(mapStateToProps, mapDispatchToProps)(ManageValidCode);
